<template>
  <div>
    <Toolbar :handle-reset="resetForm" :handle-submit="onSendForm"></Toolbar>
    <SpeakerForm :errors="violations" :values="item" ref="createForm"/>
    <Loading :visible="isLoading"/>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {createHelpers} from 'vuex-map-fields';
import SpeakerForm from '../../components/speaker/CreateForm';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Speaker';

const {mapFields} = createHelpers({
  getterType: 'speaker/getField',
  mutationType: 'speaker/updateField'
});

export default {
  name: 'SpeakerCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    SpeakerForm
  },
  data() {
    return {
      item: {
        profile: {},
        locked: true
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('speaker', ['create', 'reset']),
    getItemSubs() {
      return {
        profile: {}
      }
    }
  }
};
</script>
